"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseL2TBTCToken = void 0;
const adapter_1 = require("../ethereum/adapter");
const contracts_1 = require("../contracts");
const ethereum_1 = require("../ethereum");
const BaseTBTC_json_1 = __importDefault(require("./artifacts/base/BaseTBTC.json"));
const BaseTBTC_json_2 = __importDefault(require("./artifacts/baseSepolia/BaseTBTC.json"));
/**
 * Implementation of the Base L2TBTCToken handle.
 * @see {L2TBTCToken} for reference.
 */
class BaseL2TBTCToken extends adapter_1.EthersContractHandle {
    constructor(config, chainId) {
        let deployment;
        switch (chainId) {
            case contracts_1.Chains.Base.BaseSepolia:
                deployment = BaseTBTC_json_2.default;
                break;
            case contracts_1.Chains.Base.Base:
                deployment = BaseTBTC_json_1.default;
                break;
            default:
                throw new Error("Unsupported deployment type");
        }
        super(config, deployment);
    }
    // eslint-disable-next-line valid-jsdoc
    /**
     * @see {L2TBTCToken#getChainIdentifier}
     */
    getChainIdentifier() {
        return ethereum_1.EthereumAddress.from(this._instance.address);
    }
    // eslint-disable-next-line valid-jsdoc
    /**
     * @see {L2TBTCToken#balanceOf}
     */
    balanceOf(identifier) {
        return this._instance.balanceOf(`0x${identifier.identifierHex}`);
    }
}
exports.BaseL2TBTCToken = BaseL2TBTCToken;
//# sourceMappingURL=l2-tbtc-token.js.map